import React from 'react';
import {
  ApHeaderBarMenuIconTrigger,
  ApMenuItem,
  ApMenuUser,
  ApHeaderBar,
} from '@alixpartners/ui-components';
import { ApAuthenticationContextConsumer } from '@alixpartners/ui-utils';
import { truncateText, getInitialsFromUserName } from '../../../utils/common';
import {
  Wrapper,
  NavLink,
  HeaderWrapper,
  LogoWrapper,
  Logo,
  Separator,
} from './ClientReportHeader.styles';
import { IReport } from '../../../types';

interface IClientReportHeader {
  clientName?: string;
  sharedReports: IReport[] | null;
  onFullscreenClick: () => void;
  fullscreenButtonDisabled: boolean;
  onFiltersClick: () => void;
  filtersDisabled: boolean;
  filtersShowing: boolean;
  onBookmarksClick: () => void;
  bookmarksDisabled: boolean;
  bookmarksShowing: boolean;
  obscure?: boolean;
}

export const ClientReportHeader: React.FC<IClientReportHeader> = ({
  clientName,
  sharedReports,
  onFullscreenClick,
  fullscreenButtonDisabled,
  onFiltersClick,
  filtersDisabled,
  filtersShowing,
  onBookmarksClick,
  bookmarksDisabled,
  bookmarksShowing,
  obscure,
}) => {
  return (
    <ApAuthenticationContextConsumer>
      {({ logout, user }) => {
        return (
          <HeaderWrapper>
            <ApHeaderBar
              logo={
                <LogoWrapper>
                  <Logo />
                  <Separator /> Working Capital
                </LogoWrapper>
              }
              rightMenu={() => (
                <Wrapper>
                  {!obscure ? (
                    <>
                      {sharedReports?.map((report) => {
                        const title = report.displayName || report.reportName;
                        return (
                          <NavLink key={report.id} to={`../${report.id}`}>
                            {truncateText(title, 32)}
                          </NavLink>
                        );
                      })}
                      <ApHeaderBarMenuIconTrigger
                        iconName="baseline_fullscreen"
                        theme="dark"
                        onClick={onFullscreenClick}
                        disabled={fullscreenButtonDisabled}
                      />
                      <div
                        style={{
                          opacity: filtersShowing ? 1 : 0.4,
                        }}
                      >
                        <ApHeaderBarMenuIconTrigger
                          iconName="outline_filter_list"
                          theme="dark"
                          onClick={onFiltersClick}
                          disabled={filtersDisabled}
                          iconProps={{
                            iconColor: '#FF0000',
                          }}
                        />
                      </div>
                      <div
                        style={{
                          opacity: bookmarksShowing ? 1 : 0.4,
                        }}
                      >
                        <ApHeaderBarMenuIconTrigger
                          iconName="outlined_bookmark_border"
                          theme="dark"
                          onClick={onBookmarksClick}
                          disabled={bookmarksDisabled}
                          iconProps={{
                            iconColor: '#FF0000',
                          }}
                        />
                      </div>
                    </>
                  ) : null}
                  <ApMenuUser
                    initials={getInitialsFromUserName(user?.profile?.name)}
                  >
                    <ApMenuItem onClick={logout}>Logout</ApMenuItem>
                  </ApMenuUser>
                </Wrapper>
              )}
            />
          </HeaderWrapper>
        );
      }}
    </ApAuthenticationContextConsumer>
  );
};
